import { Dropdown, Form, StrictDropdownProps } from "semantic-ui-react";

export type FilterMultiSelectProps<TValue extends string | number> = Omit<
  StrictDropdownProps,
  "id" | "name" | "multiple" | "value" | "onChange"
> & {
  name: string;
  label: string;
  ariaLabel?: string;
  value: TValue[];
  onChange: (value: TValue[]) => void;
};

const FilterMultiSelect = <TValue extends string | number>({
  name,
  label,
  ariaLabel,
  placeholder,
  value,
  onChange,
  ...dropdownProps
}: FilterMultiSelectProps<TValue>) => (
  <Form.Field inline>
    <label htmlFor={name}>{label}</label>
    <Dropdown
      clearable
      selection
      multiple
      id={name}
      name={name}
      aria-label={ariaLabel ?? label}
      placeholder={placeholder ?? label}
      value={value}
      onChange={(_, data) => onChange(data.value as TValue[])}
      {...dropdownProps}
    />
  </Form.Field>
);

export default FilterMultiSelect;
